import React, { forwardRef, useContext } from 'react'
import ErrorMessage from 'app/React/Components/misc/ErrorMessage'
import PropTypes from 'prop-types'
import { format } from 'date-fns'
import { da } from 'date-fns/locale'
import DatePicker from 'react-datepicker'
import { ConfiguratorContext } from "app/React/ConfiguratorContainer";

function EnvDateInput(props) {
  const {
    errors,
    order,
    setErrors,
    setOrder,
    defaultValidateSteps
  } = useContext(ConfiguratorContext)

  const { name, placeholder } = props

  const value = order[name] !== undefined ? new Date(order[name]) : null

  const onChange = (date) => {
    order[name] = format(date, 'yyyy-MM-dd', { locale: da })
    setOrder({ ...order })

    const { [name]: _, ..._errors } = errors
    setErrors(_errors)

    defaultValidateSteps()
  }

  const CustomInput = forwardRef(({ value, onClick }, ref) => {
    const newDate = new Date(value)
    let dateString = ''

    if (value && newDate) {
      dateString = newDate
        .toLocaleString('da-DK', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })
        .replace('den', 'd.')

      const firstLetter = dateString.charAt(0).toUpperCase()
      const slicedDateString = dateString.slice(1)

      dateString = firstLetter + slicedDateString
    }

    return (
      <button ref={ref} onClick={onClick} className='datepicker-input'>
        <svg xmlns='http://www.w3.org/2000/svg' width='18.5' height='19.5' viewBox='0 0 18.5 19.5'
             className='datepicker-input__date-icon'>
          <g id='calendar_9_' data-name='calendar (9)' transform='translate(-1.85 -1.375)'>
            <rect id='Rectangle_189742' data-name='Rectangle 189742' width='17' height='16' rx='2'
                  transform='translate(2.6 4.125)' fill='none' stroke='#000' strokeLinecap='round'
                  strokeLinejoin='round' strokeWidth='1.5'/>
            <line id='Line_5331' data-name='Line 5331' y2='3' transform='translate(14.6 2.125)' fill='none'
                  stroke='#000' strokeLinecap='round' strokeLinejoin='round' strokeWidth='1.5'/>
            <line id='Line_5332' data-name='Line 5332' y2='3' transform='translate(7.6 2.125)' fill='none' stroke='#000'
                  strokeLinecap='round' strokeLinejoin='round' strokeWidth='1.5'/>
            <line id='Line_5333' data-name='Line 5333' x2='17' transform='translate(2.6 9.125)' fill='none'
                  stroke='#000' strokeLinecap='round' strokeLinejoin='round' strokeWidth='1.5'/>
          </g>
        </svg>
        <span className='datepicker-input__text'>{dateString || placeholder}</span>
        {
          dateString
            ? <svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 20'>
              <g id='Group_23303' data-name='Group 23303' transform='translate(-464 -331.938)'>
                <rect id='Rectangle_189749' data-name='Rectangle 189749' width='20' height='20' rx='10'
                      transform='translate(464 331.938)' fill='#247afd'/>
                <path id='Path_24008' data-name='Path 24008' d='M4.444,8.439,7.6,11.191l3.945-5.5'
                      transform='translate(466.006 333.936)' fill='none' stroke='#fff' strokeLinecap='round'
                      strokeLinejoin='round' strokeWidth='2'/>
              </g>
            </svg>
            : null
        }
      </button>
    )
  })

  return (
    <>
      <DatePicker
        selected={value}
        onChange={onChange}
        dateFormat='yyyy-MM-dd'
        locale={da}
        minDate={new Date()}
        customInput={<CustomInput/>}
      />
      {props.required === true ? <ErrorMessage field={name}/> : null}
    </>
  )
}

EnvDateInput.defaultProps = {
  required: true
}

EnvDateInput.propTypes = {
  name: PropTypes.string.isRequired,
  required: PropTypes.bool
}

export default EnvDateInput
